import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';

import {AuthGuardService} from '@app/auth/auth-guard.service';
import {ContactComponent} from '@app/landing/contact/contact.component';
import {LandingComponent} from '@app/landing/landing/landing.component';
import {PricingComponent} from '@app/landing/pricing/pricing.component';
import {PrivacyComponent} from '@app/landing/privacy/privacy.component';
import {TermsComponent} from '@app/landing/terms/terms.component';
import {UpgradeComponent} from '@app/landing/upgrade/upgrade.component';

const routes: Routes = [
    { path: '', component: LandingComponent, pathMatch: 'full' },
    { path: 'pricing', component: PricingComponent },
    { path: 'contact', component: ContactComponent },
    { path: 'terms', component: TermsComponent },
    { path: 'privacy', component: PrivacyComponent },
    { path: 'upgrade', component: UpgradeComponent, canActivate: [AuthGuardService] },
];

@NgModule({
    imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled' })],
    exports: [RouterModule],
})
export class LandingRoutingModule {}
